import React from 'react';
import { DateTimeUtils, DYLAvatar, Person, Table, } from 'dyl-components';

import { MathUtils, PhoneUtil, StringUtils } from 'utils';

export const UsageStatsTextsTableRow = ({ text }) => {
    return (
        <Table.Row>
            <Table.Cell >
                <div><b>{DateTimeUtils.formatEpoch(text.created || text?.log_info?.created, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                <div>{DateTimeUtils.formatEpoch(text.created || text?.log_info?.created, DateTimeUtils.TIME_FORMAT)}</div>
            </Table.Cell>
            <Table.Cell className="UsageStatesTexts--Person" >
                {text?.text_id?.length > 0 && text?.contact_info?.id ? <Person
                    username={text?.contact_info?.name}
                    email={text?.contact_info?.phone ? PhoneUtil.formatPhoneNumber(text?.contact_info?.phone) : ''}
                    subtitleLabel="Phone"

                /> :text?.log_info?.contact_phone_number && PhoneUtil.formatPhoneNumber(text?.log_info?.contact_phone_number)}
            </Table.Cell>
            <Table.Cell >
                {text?.log_info?.customer_phone_number && text?.text_id?.length > 0 && PhoneUtil.formatPhoneNumber(text?.log_info?.customer_phone_number)}
            </Table.Cell>
            <Table.Cell >
                {text.user_info.id && text?.text_id?.length > 0 && <DYLAvatar
                    name={text.user_info.first_name + " " + text.user_info.last_name}
                    size="2.5em"
                    inactive={!text.user_info.active}
                    title={" "}
                />}
            </Table.Cell>
            <Table.Cell >
                {text?.text_id?.length > 0 && text?.log_info?.direction && (StringUtils.capitalize(text?.log_info?.direction) + " " + text?.log_info?.text_type?.toUpperCase()) }
            </Table.Cell>
            <Table.Cell >
                {!text?.text_id?.length && <>${StringUtils.formatDecimal(`${MathUtils.roundDecimals(text?.amount)}`, true)}</>}
            </Table.Cell>
            <Table.Cell >
                {text?.text_id?.length > 0 && <div className={`TransactionHistoryTable__TransactionStaus--failed`}>
                    ${StringUtils.formatDecimal(`${MathUtils.roundDecimals(text?.amount)}`, true)}
                </div>}
            </Table.Cell>
            <Table.Cell >
                ${StringUtils.formatDecimal(`${MathUtils.roundDecimals(text?.balance)}`, true)}
            </Table.Cell>
        </Table.Row>
    );
}
